"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BottomSheet from "@/components/ui/BottomSheet";
import { useProfileDetailsSheetStore } from "@/store/profileDetailsSheetStore";
import ProfileDetailsList from "../../_components/DpComponents/ProfileDetailsList";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
const HIGHLIGHT_MS = 1500;
// Keeps the row clear of the sticky section heading.
const SCROLL_TOP_OFFSET = 48;
export default function ViewMoreDetails(t0) {
  const $ = _c(31);
  const {
    digitalProfile,
    address
  } = t0;
  const openBottomSheet = useProfileDetailsSheetStore(_temp);
  const highlightKey = useProfileDetailsSheetStore(_temp2);
  const open = useProfileDetailsSheetStore(_temp3);
  const close = useProfileDetailsSheetStore(_temp4);
  const clearHighlight = useProfileDetailsSheetStore(_temp5);
  const track = useInhomzTrack();
  let t1;
  if ($[0] !== highlightKey) {
    t1 = container => {
      const row = highlightKey && container?.querySelector(`[data-detail-key="${highlightKey}"]`);
      if (!row) {
        return;
      }
      container.scrollTo({
        top: container.scrollTop + row.getBoundingClientRect().top - container.getBoundingClientRect().top - SCROLL_TOP_OFFSET,
        behavior: "smooth"
      });
    };
    $[0] = highlightKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const scrollToHighlight = t1;
  let t2;
  let t3;
  if ($[2] !== clearHighlight || $[3] !== highlightKey) {
    t2 = () => {
      if (!highlightKey) {
        return;
      }
      const timer = setTimeout(clearHighlight, HIGHLIGHT_MS);
      return () => clearTimeout(timer);
    };
    t3 = [highlightKey, clearHighlight];
    $[2] = clearHighlight;
    $[3] = highlightKey;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== digitalProfile || $[7] !== open || $[8] !== track) {
    t4 = () => {
      track(inhomzEvents.contractorProfile.VIEW_MORE_CLICKED, {
        ...profileEventProps(digitalProfile),
        placement: "button"
      });
      open();
    };
    $[6] = digitalProfile;
    $[7] = open;
    $[8] = track;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <InfoOutlinedIcon sx={{
      fontSize: 18
    }} />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <button type="button" className="cursor-pointer m3-label-large flex items-center justify-center gap-2 m-auto px-5 py-[10px] rounded-lg border border-[--colorSurfaceSurfaceOpacity12] text-[--textLinkOnSurfaceLink]" onClick={t4}>{t5}View more details</button>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <hr className="border-t border-gray-200 mt-4" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <div className="flex flex-col bg-white md:hidden">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== address || $[17] !== digitalProfile || $[18] !== highlightKey) {
    t9 = <ProfileDetailsList digitalProfile={digitalProfile} address={address} highlightKey={highlightKey} />;
    $[16] = address;
    $[17] = digitalProfile;
    $[18] = highlightKey;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="py-5" />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== scrollToHighlight || $[22] !== t9) {
    t11 = <div ref={scrollToHighlight} className="p-4 max-h-[75vh] overflow-y-auto">{t9}{t10}</div>;
    $[21] = scrollToHighlight;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== close || $[25] !== openBottomSheet || $[26] !== t11) {
    t12 = <BottomSheet open={openBottomSheet} onClose={close}>{t11}</BottomSheet>;
    $[24] = close;
    $[25] = openBottomSheet;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t8) {
    t13 = <>{t8}{t12}</>;
    $[28] = t12;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
function _temp5(s_3) {
  return s_3.clearHighlight;
}
function _temp4(s_2) {
  return s_2.close;
}
function _temp3(s_1) {
  return s_1.open;
}
function _temp2(s_0) {
  return s_0.highlightKey;
}
function _temp(s) {
  return s.isOpen;
}